import { render } from "./AgentBookingReportList.vue?vue&type=template&id=b082d6b2"
import script from "./AgentBookingReportList.vue?vue&type=script&lang=js"
export * from "./AgentBookingReportList.vue?vue&type=script&lang=js"

import exportComponent from "/home/paiscaler-travelcrmdev/htdocs/travelcrmdev.paiscaler.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__